import React from 'react';
import { connect } from 'react-redux'
import '../login.css';
import {fireInAppBrowserPlugin} from '../actions/environmentActions';
import { resourceApi } from '../utils/fetchUtil';
import HeaderSmall from '../Components/Header/HeaderSmall';
import Divider from 'material-ui/Divider';
import FlatButton from 'material-ui/FlatButton';
import {List, ListItem } from 'material-ui/List';
import Avatar from 'material-ui/Avatar';
import Paper from 'material-ui/Paper';
import Lightbox from 'react-image-lightbox';
import ChevronRight from 'material-ui/svg-icons/navigation/chevron-right';

class DocumentsPage extends React.Component {

    constructor(props) {
        super(props);

        this.state = {  
            documents: [],
            viewImage: false,
            viewInAppBrowser: false
        };
    }

    componentDidMount() {
        this.loadDocuments();
    }

    viewImage = (i) => {

        var path = i.Url.toLowerCase();
        if(
            (path.indexOf('.png') >= 0) || 
            (path.indexOf('.jpg') >= 0) || 
            (path.indexOf('.jpeg') >= 0)){

            this.setState({ viewImage: true, image: i });
        }

        if(path.indexOf('.pdf') >= 0) {
            fireInAppBrowserPlugin(i.Url);
        }
    }

    close = () => {
        this.setState({ viewImage: false, image: null });
    }
    
    loadDocuments() {

        var self = this;

        this.setState({fetching: true});
        
        let config = {
            method: 'get',
            url: `member/documents`
        };

        resourceApi(config)
        .then(function (response) {
            console.log(response);
            self.setState({ documents: response.data });
            self.setState({ fetching: false });
        });
    }

    render() {
        return (
            <div>
                <HeaderSmall title="Documents" />  
                <br />
                <div style={{margin:'0px 15px 0 15px'}}>
                    {!this.state.viewImage && !this.state.viewInAppBrowser && (
                        <div>
                            {(this.state.documents.length === 0) && (
                                <div style={{textAlign: 'center', padding:15, height: 250}}>
                                    <p>No documents available</p>
                                </div>
                            )}

                            {this.state.documents.map((i, index) => (
                                <div key={index} >
                                    <Paper>
                                        <ListItem value={index}
                                            primaryText={
                                                <div style={{padding: '0px 10px 5px 0px'}} >
                                                    <b>{(i.Name ? i.Name : "Document")}</b>
                                                </div>
                                            }
                                            secondaryText={
                                                i.Description ? i.Description : i.DateUploaded 
                                            }
                                            onClick={() => this.viewImage(i)}
                                            leftAvatar={
                                                <Avatar
                                                    size={40}
                                                    style={{margin: 5}}
                                                    backgroundColor={window.muiTheme.palette.secondary1Color || window.muiTheme.palette.primary1Color} 
                                                >
                                                    <div><i className={i.Icon}></i></div>
                                                </Avatar>
                                            }
                                            rightIcon={<ChevronRight />}
                                        />
                                    </Paper>
                                    <br />
                                </div>
                            ))}
                        </div>
                    )}

                    {this.state.viewImage && (
                        <div>
                             <Lightbox
                                mainSrc={this.state.image.Url}
                                onCloseRequest={this.close}
                            />
                        </div>
                    )}
               </div>
            </div>
        );
    }
   
}


const mapDispatchToProps = (dispatch) => {
  return {
    
  }
}

const mapStateToProps = (state) => ({
    member: state.thisApp.auth.member
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DocumentsPage)


// WEBPACK FOOTER //
// ./src/Pages/Documents.js